import React from 'react';
import {iconName, typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {withMeta, Plugins, Atom} from '@packages/systems/wfdl';
import {
  __DEPRECATED__logInErrorStates,
  ERROR_MSG_CLASS,
  ERROR_ATTRIBUTE_PREFIX,
  LOGIN_UI_ERROR_CODES,
} from '@packages/systems/users/constants';
import {getErrorAttrName} from '../utils';

import {TTypeConstructor} from '@packages/systems/wfdl-ast';

const UserLogInErrorMsg = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const updatedClasses = classes.push(ERROR_MSG_CLASS);

    const errorKeys = Object.keys(__DEPRECATED__logInErrorStates);

    const errorMessagesById = errorKeys.reduce<Record<string, any>>(
      (acc, key) => {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"GENERAL_ERROR" | "INVALID_EMAIL_OR_PASSWORD", ErrorStateType>>'.
        const {id} = __DEPRECATED__logInErrorStates[key];
        // We now use a more generic data path for multi text state editing but fall back to legacy
        // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
        acc[id] = data?.textStateCopy?.[id] ?? data?.users?.[id];
        return acc;
      },
      {}
    );

    const currentMessage =
      errorMessagesById[
        // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
        data?.temp?.state ?? LOGIN_UI_ERROR_CODES.GENERAL_ERROR
      ];

    const errorsAttr = errorKeys.reduce<Record<string, any>>(
      (acc, errorKey) => {
        const errorAttrName = getErrorAttrName(
          ERROR_ATTRIBUTE_PREFIX.LOGIN,
          errorKey
        );
        acc[errorAttrName] =
          // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"GENERAL_ERROR" | "INVALID_EMAIL_OR_PASSWORD", ErrorStateType>>'.
          errorMessagesById[__DEPRECATED__logInErrorStates[errorKey].id];

        return acc;
      },
      {}
    );

    return (
      <div {...generateAttributes(attributes, updatedClasses)} {...errorsAttr}>
        {currentMessage}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Log In Error',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: false,
  render: UserLogInErrorMsg,
  constraints: {
    pinToParent: true,
    parent: [{is: 'UserFormErrorState', rule: 'ExactlyOne'}],
  },
  hideAncestorSettings: true,
  dataType: withMeta(
    {
      textStates: __DEPRECATED__logInErrorStates,
      legacyStatePath: ['users'],
    },
    // TODO: this needs to be converted to an Alias https://webflow.atlassian.net/browse/PLAT-639
    TTypeConstructor(
      qualify(Plugins.name('Commerce'), typeName('MultiTextEdit'))
    )
  ),
});

export default config;
